module.exports = __webpack_public_path__ + "static/AADC-logo-da54a0b0895f1c57f5c09168c1b9029e.jpeg";